module.exports = function mixin(to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/util/mixin.js
// module id = 563
// module chunks = 0